import { render, staticRenderFns } from "./SiatRiepilogoPraticheListPage.vue?vue&type=template&id=bbbc5d96&scoped=true"
import script from "./SiatRiepilogoPraticheListPage.vue?vue&type=script&lang=js"
export * from "./SiatRiepilogoPraticheListPage.vue?vue&type=script&lang=js"
import style0 from "./SiatRiepilogoPraticheListPage.vue?vue&type=style&index=0&id=bbbc5d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbc5d96",
  null
  
)

export default component.exports